import { BaseQueryFn, EndpointBuilder, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Department, ResponseList } from "types";
import apiRoutes from "../apiRoutes";

export const departmentApi = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, string, "api">) => ({
    getDepartment: builder.query<ResponseList<Department>, void>({
        query: () => apiRoutes.getDepartment,
    }),
})